module.exports = __webpack_public_path__ + "static/media/filter.f614c7b5.svg";